<template>
  <div class="about">
    <div class="container banner">
      <img src="../../static/img/about/banner.png" class="top-banner" alt="">
      <div class="content">
        <div class="bread">
          您现在的位置：
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item >最新动态</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="about-title">
          <h3 class="meal-title"><span class="title-line"></span>最新动态<span class="title-line"></span></h3>
        </div>
        <div class="about-article">
          <div class="taggle-box">
            <ul>
              <li @click="setActive(item.id)" class="fun-carousel" :class="{'active':item.id===index?true:false}" v-for="item in diaryCarList" :key="item.id">
                {{item.name}}
              </li>
            </ul>
          </div>
          <div style="clear: both"></div>
          <div class="team-group">
            <ul>
              <!--v-for="item in teamList" :key="item.id"-->
              <li class="team-item" v-for="item in teamList" :key="item.id">
                <div class="img-box">
                  <img :src="item.picUrl" alt="">
                </div>
                <div class="team-intro">
                  <div class="date-box">
                    <p class="dy">{{item.dateY}}</p>
                    <p class="dd">{{item.dateD}}</p>
                  </div>
                  <div class="cont">
                    <p class="name" @click="toDetail(item.id)" v-if="item.name">{{item.name}}</p>
                    <div class="team-content" v-html="item.describe"></div>
                  </div>
                </div>
                <div class="check-d" @click="toDetail(item.id)">

                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Daily from '../assets/data/dynamic';

  export default {
    name: "dynamic",

    data(){
      return{
        index:1,
        diaryCarList:[
          {
            name:'月子科普 ',
            id:1
          },
          {
            name:'合美资讯 ',
            id:2
          },
          {
            name:'优惠活动',
            id:3
          },
        ],
        teamList:[],
        teamListF:[],
        teamListS:[],
        teamListT:[],
      }
    },
    created(){
      this.teamListF = Daily.article;
      this.teamListS = Daily.dynamic;
      this.teamListT = Daily.active;
      this.setActive(1)
    },
    methods:{
      toDetail:function(id){
        this.$router.push({
          path: `/dynamicDetail/${id}`,
        })
      },
      setActive:function (id) {
        var _this = this

        this.index = id;
        switch (id) {
          case 1:
            _this.$set(_this.$data,"teamList",this.teamListF);
            break;
          case 2:
            this.teamList = this.teamListS;
            break;
          case 3:
            this.teamList = this.teamListT;
            break;
          case 4:
            this.teamList = this.teamListL;
            break;
        }
        console.log(this.teamList)
      },
    }
  }
</script>

<style scoped lang="less">
  .about{
    .banner{
      .top-banner{
        width: 100%;
        margin-bottom: 20px;
      }
      .bread{
        margin-bottom: 20px;
        font-size: 12px;
        color:#999999;
        .el-breadcrumb{
          vertical-align: middle;
          display: inline-block;
          span{
            font-size: 12px;
            color:#999999;
          }
        }
      }
      .about-title{
        margin-bottom: 32px;
      }
      .about-article{
        margin-bottom: 80px;
        .pre-text{
          text-indent: 20px;
          line-height: 24px;
          font-size: 14px;
          color:#666666;
          margin-bottom: 36px;
        }
        .taggle-box{
          margin-bottom: 50px;
          ul{
            display: flex;
            flex-direction: row;
            justify-content: center;
            .fun-carousel{
              width: 186px;
              height: 36px;
              color:#666666;
              text-align: center;
              line-height: 36px;
              border-radius: 18px;
              float: left;
              cursor: pointer;
              border: 1px solid #666666;
              margin-right: 30px;
              &:last-child{
                margin-right: 0;
              }
            }
            .fun-carousel.active{
              background-color: #c2874e;
              color:#ffffff;
              border-color: #c2874e;
            }
          }
        }
        .team-item{
          margin-bottom: 40px;
          width: 100%;
          height: 214px;
          background-color: #ffffff;
          display: flex;
          flex-direction: row;
          justify-content: left;
          border-bottom: 1px solid #cccccc;
          &:hover{
            box-shadow: 0 0 30px rgba(0,0,0,0.2);
          }
          .img-box{
            height: 214px;
            width: 342px;
            display: flex;
            margin-right: 52px;
            justify-content: center;
            img{
              height: 100%;
              width: 100%;
            }
          }
          .team-intro{
            display: flex;
            flex-direction: row;
            justify-content: left;
            padding: 55px 0;
            .date-box{
              width: 80px;
              margin-right: 26px;
              color:#B97530;
              font-style: italic;
              font-weight: 600;
              .dy{
                font-size: 30px;
              }
              .dd{
                font-size: 18px;
              }
            }
            .cont{
              width: 680px;
              height: 79px;
              border-left: 1px solid #B97530;
              padding-left: 30px;
              .name{
                cursor: pointer;
                font-weight: 600;
                margin-bottom: 18px;
                font-size: 16px;
                line-height: 22px;
                color:#333333;
              }
              .team-content{
                width: 650px;
                font-size: 14px;
                line-height: 22px;
                color:#666666;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
              }
            }

          }
          .check-d{
            float: right;
            width: 31px;
            height: 30px;
            background: url('../../static/img/tb.png') no-repeat 0 -164px;
            margin-top: 90px;
            margin-left: 16px;
            &:hover{
              background-position: -71px -164px;
            }
          }
        }
      }
    }
  }
  .meal-title{
    margin-bottom: 8px;
    text-align: center;
    font-size: 28px;
    line-height: 32px;
    font-weight: 500;
    .title-line{
      width: 65px;
      height: 1px;
      margin:0 30px;
      display: inline-block;
      background-color: #cccccc;
      vertical-align: middle;
    }
  }
  .sub-title{
    color:#b3b3ba;
    text-align: center;
  }
</style>




// WEBPACK FOOTER //
// src/components/dynamic.vue